<template>
  <div>


    <div v-if="isInMSDK || (userAgent.weixin && (userAgent.iOS || userAgent.android)) || userAgent.QQ">
      <div class="head">
        <img src="../../../ui/20190114/img/head-bg.jpg" alt="img">
      </div>


      <div class="pop-bg" v-if="isOpenerFirstBargainDialogShown || isWechatShareGuideShown">
        <!--开砍弹窗-->
        <div class="pop bargain-start-pop" v-show="isOpenerFirstBargainDialogShown">
          <div class="close" @click="closeStartBargainDialog"></div>
          <div class="title">
            <div class="line l-line"></div>
            砍价开始
            <div class="line r-line"></div>
          </div>
          <div class="content">
            <p class="txt">
              您已成功给自己砍掉<span class="imp">{{firstBargainInfo.price}}</span>点券，邀请好友帮忙砍价，有机会砍爆底价，暴击至1折哦～
            </p>
            <p class="desc">倒计时{{firstBargainInfo.countdown}}小时计时开始！</p>
            <!-- 游戏外分享 -->
            <div class="btn buy-btn share-btn" v-if="!isInMSDK" @click="share"><p>立即邀请</p></div>
          </div>
          <!-- 游戏内分享 -->
          <div class="shop-box share-block" v-if="isInMSDK">
            <div class="title">
              <div class="line l-line"></div>
              邀请好友帮砍
              <div class="line r-line"></div>
            </div>
            <div class="zj-box">
              <ul>
                <li @click="inGameShare('pengy','__mds_client.timeline.bargain')">
                  <img src="../../../ui/20190114/img/wechatfind-share.png" alt="img"/>
                  <p>分享至朋友圈</p>
                </li>
                <li @click="inGameShare('weixin','__mds_client.wx.bargain')">
                  <img src="../../../ui/20190114/img/wechat-share.png" alt="img"/>
                  <p>分享至微信</p>
                </li>
                <li @click="inGameShare('qq','__mds_client.qq.bargain')">
                  <img src="../../../ui/20190114/img/qq-share.png" alt="img"/>
                  <p>分享至QQ</p>
                </li>
                <li @click="inGameShare('qzone','__mds_client.qzone.bargain')">
                  <img src="../../../ui/20190114/img/qqzong-share.png" alt="img"/>
                  <p>分享至空间</p>
                </li>
              </ul>
            </div>
          </div>

        </div>

        <!-- 分享引导 -->
        <div class="share-tips-pop" @click="closeWechatShareTips()"
             v-show="isWechatShareGuideShown">
          <div class="tips-pic"></div>
        </div>
      </div>


      <div class="section">

        <router-view>

        </router-view>
      </div>
    </div>
    <div class="section login" style="position: absolute" v-else>
      <div class="logo1">王者荣耀</div>
      <div class="logo2">腾讯充值</div>
      <div class="login-tips">集合！准备开砍！</div>
      <div class="btn-box">
        <button class="qq-login xbtn" @click="goToQQ"><p>QQ登录</p></button>
        <button class="wechat-login xbtn" @click="goToWechat"><p>微信登录</p></button>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../ui/20190114/css/style-index.css"
import "../../../ui/20190114/css/page.css"
import { mapState, mapActions, mapGetters } from "vuex"
import * as configs from "./config"

export default {
  name: "App",
  data() {
    return {
      isWechatShareGuideShown: false
    }
  },
  computed: {
    ...mapState(["isInMSDK", "userAgent"]),
    ...mapGetters(["isOpenerFirstBargainDialogShown", "firstBargainInfo", "offerId"])
  },
  mounted() {
    if (!this.isInMSDK && !(this.userAgent.weixin && (this.userAgent.iOS || this.userAgent.android)) && !this.userAgent.QQ) {
      // this.getLoginState()
      document.querySelector("#page_loading").style.display = "none"
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.ENTER_OUTSIDE_OF_GAME_OR_WECHAT_OR_QQ
      })
    }
  },
  methods: {
    ...mapActions([
      "jumpToWechat",
      "jumpToMqq",
      "getLoginState",
      "msdkShareTo",
      "setOpenerBargainDialog",
      "showMqqShareMenu",
      "reportUserAction",
      "setOnShareHandler",
      "setOpenerBargainDialog"
    ]),
    closeRuleDialog() {
      this.isRuleShown = false
    },
    closeStartBargainDialog() {
      this.setOpenerBargainDialog(false)
    },
    share() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.START_BARGAIN_THEN_INVITE_FRIENDS
      })
      if (this.userAgent.weixin) {
        this.isWechatShareGuideShown = true
      } else if (this.userAgent.QQ) {
        this.showMqqShareMenu()
      }
      this.setOpenerBargainDialog(false)
    },
    closeWechatShareTips() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.START_BARGAIN_THEN_CLOSE_DIALOG
      })
      this.isWechatShareGuideShown = false
    },
    inGameShare(selected, pf) {
      this.msdkShareTo({
        selected,
        bargainId: this.firstBargainInfo.bargainId,
        pf,
        offerId: this.offerId,
        item: this.firstBargainInfo.item
      })
    },
    goToQQ() {
      this.jumpToMqq(location.href)
    },
    goToWechat() {
      this.jumpToWechat(configs.WECHAT_OPENLINK)
    }
  }
}
</script>

<style scoped>
</style>
